import { FikoYTEnvIstemci } from '@/src/service/Environment/environment';
import { CommonModule, DOCUMENT } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ComponentRef, ElementRef, EventEmitter, Inject, Injector, input, Input, model, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import { PaylasTextEditorComponent } from '../../IKart/paylas-text-editor/paylas-text-editor.component';
import { FormsModule } from '@angular/forms';
// import { KartComponent } from '../../kart/kart.component';
// import { NgZorroModulleri } from '@/src/app/servisler/FikoYT/moduller/ng-zorro.module';
import { YapayZekaComponent } from './yapay-zeka/yapay-zeka.component';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { IIcerik, IEkTuru, IYuzEtiketi } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { FikoSesOynaticiComponent } from '@/src/service/fikoyt-ui/src/lib/fiko-ses-oynatici/fiko-ses-oynatici.component';
import { IUyarKartComponent } from './IUyarDokum/uyar-kutusu.component';
import { FikoYTIstekKok } from '@/src/service/modules/fikoyt-istek-kok/fikoyt.istek.makinesi.service';
import { escapeRegex } from '@/src/app/shared/utils/regex.utils';
import { KisiBalonV2Component } from '@/src/app/shared/components/kisi-balon/kisi-balon.component';
import { ParametreSetiSeciciComponent } from '../parametre-seti-secici/parametre-seti-secici.component';
import { ParametrelerComponent } from '../../../../parametreler/parametreler.component';
import { FikoTasarimEditoruComponent } from '../../../fiko-tasarim-editoru/fiko-tasarim-editoru.component';
import { ISablon, bosISablon } from '../../../sablon-editoru/sablon.interface';
import { DinamikBilesenRendererComponent } from '../../../../dinamik-bilesen/dinamik-bilesen-renderer.component';
import { FikoStpOnizlemeKartiComponent } from '@/src/service/fikoyt-ui/src/lib/fiko-three-js/fiko-stp-onizleme-karti/fiko-stp-onizleme-karti.component';

declare var $: any;
declare var imageCompression: any

@Component({
  selector: 'fikoyt-paylas-icerik-editor',
  templateUrl: './paylas-icerik-editor.component.html',
  styleUrls: ['./paylas-icerik-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    PaylasTextEditorComponent,
    YapayZekaComponent,
    NzWaveModule,
    NzPopconfirmModule,
    NzTooltipModule,
    NzInputModule,
    NzButtonModule,
    FikoSesOynaticiComponent,
    IUyarKartComponent,
    KisiBalonV2Component,
    NzPopoverModule,
    ParametreSetiSeciciComponent,
    ParametrelerComponent,
         FikoTasarimEditoruComponent,
    DinamikBilesenRendererComponent,
    FikoStpOnizlemeKartiComponent,
  ]
})
export class PaylasIcerikEditorComponent extends FikoYTKokBilesenComponent implements AfterViewInit, OnDestroy {
  @ViewChild('referansKonteynir', { read: ViewContainerRef }) referansKonteynir: ViewContainerRef;
  @ViewChild('konumEditorHarita') konumEditorHarita: ElementRef<HTMLDivElement>;
  @ViewChild('lightboxOverlay') lightboxOverlay: ElementRef<HTMLDivElement>;
  @ViewChild('sablonEditoruRef') sablonEditoruRef: any;
  @ViewChild(ParametreSetiSeciciComponent) private parametreSetiSecici: ParametreSetiSeciciComponent;
  private referansBilesenRef: ComponentRef<any> = null;
  private konumLeafletMap: any = null;
  private konumHaritaAktifId: string = null;

  @Input() saltOkunur = false;
  @Input() dinamikBilesenId: string | null = null;
  dinamikParametreler = model<any>(null);
  /** */
  kart = input(null);
  /** */
  private _icerik: IIcerik | any;
  public get icerik(): IIcerik | any {
    return this._icerik;
  }
  @Input() public set icerik(v: IIcerik | any) {
    this._icerik = v;
    this.icerikChange.emit(v);
    setTimeout(() => {
      $('.ui.embed').embed({
        source: "youtube",
        brandedUI: true
      });
    }, 0);
    // Sunucudan gelen medya ekleri → EKREFERANS'a dönüştür
    if (v?.ek && v.ek._id && !v.ek.dosya && v.ek.turu !== IEkTuru.EKREFERANS
        && v.ek.turu !== IEkTuru.REFERANS && v.ek.turu !== IEkTuru.YOUTUBE
        && v.ek.turu !== IEkTuru.UYARDOKUM && v.ek.turu !== IEkTuru.YAPAYZEKA
        && v.ek.turu !== IEkTuru.KONUM
        // NOT: DOSYA ve CAD/3D türleri hariç tutulmalı — icerikler.component.html'deki
        // *ngIf="aktifIcerik?.ek?.turu == 'DOSYA'" bloğu (STP/WRL algılama dahil) buna bağlı.
        // Bu türü EKREFERANS'a çevirmek 3D dosyayı kalıcı olarak "algılanamaz" hale getiriyordu.
        && v.ek.turu !== IEkTuru.DOSYA && v.ek.turu !== IEkTuru.FIKOWRL
        && v.ek.turu !== IEkTuru.STL && v.ek.turu !== IEkTuru.DXF
        && v.ek.turu !== IEkTuru.FIKOGL && v.ek.turu !== IEkTuru.FIKOGLS
        && v.ek.turu !== IEkTuru.FIKOOPGL && v.ek.turu !== IEkTuru.FIKOOPGLv1) {
      this.sunucuMedyayiEkReferansaDonustur(v.ek);
    }
    // Referans kart varsa dinamik yükle
    if (v?.ek?.turu === IEkTuru.REFERANS && v?.ek?.rid) {
      this.referansKartYukle(v.ek.rid);
    }
    this.CD.detectChanges();
  }
  @Output() icerikChange: EventEmitter<IIcerik> = new EventEmitter<IIcerik>();

  /** Önizleme modu: parametreleri gösterim modunda göster */
  onizlemeModu = false;

  /** Parametre seti butonu gösterilsin mi */
  @Input() parametreSetiVar = false;
  /** Parametre seti butonu aktif mi (panel açık) */
  @Input() parametreSetiAcik = false;
  /** Aktif sayfa kuralları — içerik kısıtlamaları */
  @Input() sayfaKurallari: any = null;
  /** Parametre seti grupları */
  @Input() parametreSetleri: any[] = [];
  /** Aktif sayfanın seçili set id'si */
  @Input() seciliSetId: string | null = null;
  /** Kullanıcı yetkileri */
  @Input() kullaniciYetkileri: string[] = [];
  /** Kartın parametreleri */
  @Input() kartParametreler: any[] = [];
  tasarimModu = false;
  /** Parametre seti butonuna tıklandığında */
  @Output() parametreSetiTiklandi = new EventEmitter<void>();
  /** Set seçildiğinde */
  @Output() setSecildi = new EventEmitter<any>();
  /** Set kaldırıldığında */
  @Output() setKaldirildi = new EventEmitter<void>();
  /** Parametreler değiştiğinde */
  @Output() parametrelerDegisti = new EventEmitter<any[]>();

  /** Uygulama seti seçildiğinde — parametreleri ek'e yaz */
  onUygulamaSecildi(olay: any) {
    if (this.icerik?.ek?.turu === 'UYGULAMAICERIK') {
      this.icerik.ek.parametreler = olay.parametreler;
      this.icerik.ek._secilenSetId = olay.setId;
      if (olay.bilesen) {
        this.icerik.ek.bilesen = olay.bilesen;
      } else {
        delete this.icerik.ek.bilesen;
      }
      if (olay.bilesenGorunum) {
        this.icerik.ek.bilesenGorunum = olay.bilesenGorunum;
      }
      delete this.icerik.ek.sablonOverride;
      delete this.icerik.ek.sablon;
    }
    this.tasarimModu = false;
    this.setSecildi.emit(olay);
    this.icerikChange.emit(this.icerik);
    this.CD.detectChanges();
    // Otomatik Kod parametrelerini üret
    this.otomatikKodlariUret();
  }

  private otomatikKodlariUret() {
    setTimeout(() => {
      const parametrelerRef = this.icerik?.ek?.parametreler ?? [];
      for (const p of parametrelerRef) {
        if (p.turu === 'Otomatik Kod' && !p.degeri) {
          // parametreler.component'teki otomatikKodUret'i simüle et
          const format = p.ayarlar?.kodFormat || '{PREFIX}-{YIL}-{SAYI:3}';
          const now = new Date();
          let kod = format
            .replace(/\{PREFIX\}/gi, p.ayarlar?.kodPrefix ?? 'PRJ')
            .replace(/\{YIL\}/gi, '' + now.getFullYear())
            .replace(/\{AY\}/gi, String(now.getMonth() + 1).padStart(2, '0'))
            .replace(/\{GUN\}/gi, String(now.getDate()).padStart(2, '0'))
            .replace(/\{SAAT\}/gi, String(now.getHours()).padStart(2, '0'))
            .replace(/\{DAKIKA\}/gi, String(now.getMinutes()).padStart(2, '0'))
            .replace(/\{SAYI(?::(\d+))?\}/gi, (_, hane) => String(1).padStart(parseInt(hane || '3', 10), '0'));
          // Parametre referansları
          const sistemDeg = ['PREFIX', 'YIL', 'AY', 'GUN', 'SAAT', 'DAKIKA'];
          kod = kod.replace(/\{([^}:]+)\}/g, (eslesme, ismi) => {
            if (sistemDeg.includes(ismi.toUpperCase()) || ismi.toUpperCase().startsWith('SAYI')) return eslesme;
            const diger = parametrelerRef.find((pr: any) => pr.ismi === ismi);
            return (diger?.degeri != null && diger.degeri !== '') ? '' + diger.degeri : '';
          });
          p.degeri = kod;
        }
      }
      this.CD.detectChanges();
    }, 100);
  }

  /** Uygulama seçimi kaldırıldığında */
  onUygulamaKaldirildi() {
    if (this.icerik?.ek?.turu === 'UYGULAMAICERIK') {
      this.icerik.ek.parametreler = [];
      delete this.icerik.ek._secilenSetId;
      delete this.icerik.ek.sablonOverride;
      delete this.icerik.ek.sablon;
    }
    this.tasarimModu = false;
    this.parametreSetiSecici?.secimSifirla();
    this.setKaldirildi.emit();
    this.icerikChange.emit(this.icerik);
    this.CD.detectChanges();
  }

  aktifSablon(): ISablon {
    if (this.icerik?.ek?.sablonOverride) return this.icerik.ek.sablonOverride;
    if (this.icerik?.ek?.sablon) return this.icerik.ek.sablon;
    const setSablonu = this.seciliSetSablonBul();
    if (setSablonu) return setSablonu;
    return bosISablon();
  }

  private seciliSetSablonBul(): ISablon | null {
    if (!this.seciliSetId || !this.parametreSetleri?.length) return null;
    for (const grup of this.parametreSetleri) {
      if (grup.id === this.seciliSetId && grup.sablon) return grup.sablon;
      for (const alt of (grup.altGruplar ?? [])) {
        if (alt.id === this.seciliSetId && alt.sablon) return alt.sablon;
        for (const altKart of (alt.altKartSablonlari ?? [])) {
          if (altKart.id === this.seciliSetId && (altKart as any).sablon) return (altKart as any).sablon;
        }
      }
    }
    return null;
  }

  sablonGuncelle(sablon: ISablon) {
    if (!this.icerik?.ek) return;
    this.icerik.ek.sablonOverride = sablon;
    // Sablon dosyalarını ek'e aktar (Fikola'da FormData'ya eklenecek)
    if (this.sablonEditoruRef?.sablonDosyalariAl) {
      this.icerik.ek._sablonDosyalar = this.sablonEditoruRef.sablonDosyalariAl();
    }
    this.icerikChange.emit(this.icerik);
  }

  /** Sunucudan gelen medya eklerini EKREFERANS türüne dönüştürür (kart referansı gibi çalışır) */
  private sunucuMedyayiEkReferansaDonustur(ek: any) {
    if (!ek?._id) return;
    // Orijinal türü bilgiler içinde sakla
    if (!ek.bilgiler) ek.bilgiler = {};
    ek.bilgiler.orijinalTuru = ek.turu;
    // Türü EKREFERANS olarak değiştir
    ek.turu = IEkTuru.EKREFERANS;
  }

  /** EKREFERANS gerçek referans mı (başka birinin içeriği) yoksa kendi içeriğimiz mi? */
  get gercekReferansMi(): boolean {
    const ekSahip = this.icerik?.ek?.bilgiler?.sahip;
    return !!ekSahip && ekSahip !== this.kart()?.sahip;
  }

  // Referans kart verisi
  referansKartYukleniyor = false;

  // Yüz etiketleme
  yuzEtiketModuAktif = false;
  bekleyenEtiket: { x: number; y: number; w: number; h: number } | null = null;
  yuzEtiketAramaMetni = '';
  yuzEtiketAramaSonuclari: any[] = [];
  private yuzEtiketAramaTimer: any = null;
  suruklenenEtiketId: string | null = null;
  private suruklemeBilgi: { yon: string; baslangicX: number; baslangicY: number; baslangicRect: { x: number; y: number; w: number; h: number } } | null = null;
  // Gerçek resim alanı (object-fit: contain hesabı)
  resimAlani: { left: number; top: number; width: number; height: number } | null = null;
  private resimAlaniObserver: ResizeObserver | null = null;
  private sonResimEl: HTMLImageElement | null = null;

  // Otomatik yüz tespiti (editör modunda)
  editorOtomatikYuzler: any[] = [];
  editorYuzTespitYukleniyor = false;
  editorOtomatikYuzAktifIdx: number | null = null;
  editorOtomatikYuzAramaMetni = '';
  editorOtomatikYuzAramaSonuclari: any[] = [];
  private editorYuzTespitTimer: any = null;
  private editorOtomatikYuzAramaTimer: any = null;
  private editorYuzTespitEkId: string | null = null;

  // Lightbox (gerçek tam ekran)
  lightboxAcik = false;
  lightboxZoom = 1;
  lightboxPanX = 0;
  lightboxPanY = 0;
  lightboxResimAlani: { left: number; top: number; width: number; height: number } | null = null;
  private lightboxKeydownHandler: ((e: KeyboardEvent) => void) | null = null;
  private lightboxSurukBilgi: { aktif: boolean; baslangicX: number; baslangicY: number; oncekiPanX: number; oncekiPanY: number } | null = null;

  // Aktif medya takibi (ses oynatıcı için)
  aktifMedya: string = null;

  // Mikrofon kayıt sistemi
  mikrofonKayitAktif = false;
  mikrofonSure = 0;
  mikrofonMenuGoster = false;
  whisperYukleniyor = false;
  onizlemeOynuyor = false;
  onizlemeIlerleme = 0;
  private mediaRecorder: MediaRecorder = null;
  private kayitParcalari: Blob[] = [];

  private kayitStream: MediaStream = null;
  private kayitTimer: any = null;
  private kayitBlob: Blob = null;
  private onizlemeAudio: HTMLAudioElement = null;

  constructor() {
    super();
    // setTimeout(() => {
    //   this.CD.detach();
    // })
    // if ("launchQueue" in window) {
    //   //@ts-ignore
    //   window.launchQueue.setConsumer(async (launchParams) => {

    //     if (launchParams.files && launchParams.files.length) {

    //       for (let i = 0; i < launchParams.files.length; i++) {
    //         const file = await launchParams.files[i].getFile();

    //         if (file.type.indexOf('image') === 0) {
    //           if (i == 0) {
    //             this.FikoYT.paylas.kart.veri.icerikler[0].ek = this.resimEkle(file);
    //           } else {
    //             await this.FikoYT.paylas.icerikEkle(await this.resimEkle(file));
    //           }
    //         }
    //       }
    //     }
    //     this.FikoYT.degisti.emit();
    //     // this.CD.detectChanges();
    //   });
    // }
  }


  override ngAfterViewInit(): void {
    super.ngAfterViewInit();
    $('.ui.embed').embed({
      brandedUI: true
    });

    // Lightbox'ı body'e taşı (parent transform'lar position:fixed'ı bozuyor)
    if (this.lightboxOverlay?.nativeElement) {
      this.document.body.appendChild(this.lightboxOverlay.nativeElement);
    }
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if (this.lightboxKeydownHandler) {
      this.document.removeEventListener('keydown', this.lightboxKeydownHandler);
      this.lightboxKeydownHandler = null;
    }
    if (this.lightboxAcik) {
      this.document.body.style.overflow = '';
      this.document.body.classList.remove('fikoyt-lightbox-aktif');
    }
    // Lightbox'ı body'den temizle
    if (this.lightboxOverlay?.nativeElement?.parentNode === this.document.body) {
      this.lightboxOverlay.nativeElement.remove();
    }
    if (this.konumLeafletMap) {
      this.konumLeafletMap.remove();
      this.konumLeafletMap = null;
    }
    if (this.resimAlaniObserver) {
      this.resimAlaniObserver.disconnect();
      this.resimAlaniObserver = null;
    }
    // Timer, ses kayit ve arama temizligi (memory leak onleme)
    if (this.kayitTimer) {
      clearInterval(this.kayitTimer);
      this.kayitTimer = null;
    }
    if (this.yuzEtiketAramaTimer) {
      clearTimeout(this.yuzEtiketAramaTimer);
      this.yuzEtiketAramaTimer = null;
    }
    if (this.editorYuzTespitTimer) {
      clearTimeout(this.editorYuzTespitTimer);
      this.editorYuzTespitTimer = null;
    }
    if (this.editorOtomatikYuzAramaTimer) {
      clearTimeout(this.editorOtomatikYuzAramaTimer);
      this.editorOtomatikYuzAramaTimer = null;
    }
    if (this.kayitStream) {
      this.kayitStream.getTracks().forEach(t => t.stop());
      this.kayitStream = null;
    }
    if (this.onizlemeAudio) {
      this.onizlemeAudio.pause();
      if (this.onizlemeAudio.src) URL.revokeObjectURL(this.onizlemeAudio.src);
      this.onizlemeAudio = null;
    }
    if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
      this.mediaRecorder.stop();
    }
    this.mediaRecorder = null;
    super.ngOnDestroy();
  }

  async konumHaritaBaslat() {
    const ek = this.icerik?.ek;
    if (ek?.turu !== IEkTuru.KONUM || !ek?.bilgiler?.koordinat) return;

    // Element'i bekle
    this.CD.detectChanges();
    await new Promise<void>(r => setTimeout(r, 100));

    if (!this.konumEditorHarita?.nativeElement) return;

    if (this.konumLeafletMap) {
      this.konumLeafletMap.remove();
      this.konumLeafletMap = null;
    }

    const L = await import('leaflet').then(m => m.default ?? m);
    const { lat, lng } = ek.bilgiler.koordinat;
    const el = this.konumEditorHarita.nativeElement;
    const map = L.map(el, { zoomControl: false, attributionControl: false }).setView([lat, lng], 13);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);
    const pinIcon = L.divIcon({
      className: '',
      html: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42">
        <defs><filter id="s" x="-20%" y="-10%" width="140%" height="130%"><feDropShadow dx="0" dy="2" stdDeviation="2" flood-opacity="0.3"/></filter></defs>
        <path d="M16 0C7.16 0 0 7.16 0 16c0 12 16 26 16 26s16-14 16-26C32 7.16 24.84 0 16 0z" fill="#e74c3c" filter="url(#s)"/>
        <circle cx="16" cy="16" r="7" fill="white"/>
        <circle cx="16" cy="16" r="4" fill="#e74c3c"/>
      </svg>`,
      iconSize: [32, 42],
      iconAnchor: [16, 42],
    });
    L.marker([lat, lng], { icon: pinIcon }).addTo(map);
    this.konumLeafletMap = map;
    setTimeout(() => map.invalidateSize(), 300);
  }




  tiklandiEkSil($event: any) {
    this.icerik.ek = undefined;
    if (this.konumLeafletMap) {
      this.konumLeafletMap.remove();
      this.konumLeafletMap = null;
      this.konumHaritaAktifId = null;
    }
    this.CD.detectChanges();
  }

  tiklandiIcerikTamEkran(elem: any) {
    // RESIM türünde lightbox aç
    if (this.icerik?.ek?.turu === IEkTuru.RESIM || this.icerik?.ek?.bilgiler?.orijinalTuru === 'RESIM') {
      this.lightboxAc();
      return;
    }
    // Diğer türler için native fullscreen
    if (!this.document.fullscreenElement) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      }
    }
  }

  get lightboxResimUrl(): any {
    if (this.icerik?.ek?.turu === IEkTuru.RESIM) return this.icerik.ek.dosyaObjectUrl;
    if (this.icerik?.ek?.turu === IEkTuru.EKREFERANS && this.icerik.ek.bilgiler?.orijinalTuru === 'RESIM') {
      return this.FikoYT.fapiUrl + '/fapiv1/fikoyt.com.FikoYT.sistem.dosyalar.' + this.icerik.ek._id + '.resim?boyut=1920x?&t=0';
    }
    return this.icerik?.ek?.dosyaObjectUrl;
  }

  lightboxAc() {
    this.lightboxAcik = true;
    this.lightboxZoom = 1;
    this.lightboxPanX = 0;
    this.lightboxPanY = 0;
    this.lightboxResimAlani = null;
    this.document.body.style.overflow = 'hidden';
    this.document.body.classList.add('fikoyt-lightbox-aktif');
    this.lightboxKeydownHandler = (e: KeyboardEvent) => this.lightboxKeydown(e);
    this.document.addEventListener('keydown', this.lightboxKeydownHandler);
    this.CD.detectChanges();
    // display:none→flex geçişinde resim zaten yüklüyse alan hesapla
    this._lightboxResimAlaniHesapla();
  }

  /** Lightbox resim alanını hesapla (double-RAF ile layout garantisi) */
  private _lightboxResimAlaniHesapla() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const img = this.lightboxOverlay?.nativeElement?.querySelector('.lightbox-resim') as HTMLImageElement;
        if (img?.complete && img.naturalWidth > 0) {
          this.lightboxResimYuklendi({ target: img } as any);
        }
      });
    });
  }

  lightboxKapat() {
    this.lightboxAcik = false;
    this.document.body.style.overflow = '';
    this.document.body.classList.remove('fikoyt-lightbox-aktif');
    if (this.lightboxKeydownHandler) {
      this.document.removeEventListener('keydown', this.lightboxKeydownHandler);
      this.lightboxKeydownHandler = null;
    }
    this.CD.detectChanges();
  }

  lightboxKeydown(e: KeyboardEvent) {
    switch (e.key) {
      case 'Escape': this.lightboxKapat(); break;
      case '+': case '=': this.lightboxZoomDegistir(0.25); break;
      case '-': this.lightboxZoomDegistir(-0.25); break;
      case '0': this.lightboxZoom = 1; this.lightboxPanX = 0; this.lightboxPanY = 0; this.CD.detectChanges(); break;
      case 'f': case 'F': this.yuzEtiketModuToggle(); break;
    }
  }

  lightboxZoomDegistir(delta: number) {
    this.lightboxZoom = Math.max(0.25, Math.min(8, this.lightboxZoom + delta));
    if (this.lightboxZoom <= 1) { this.lightboxPanX = 0; this.lightboxPanY = 0; }
    this.CD.detectChanges();
  }

  lightboxWheel(e: WheelEvent) {
    e.preventDefault();
    this.lightboxZoomDegistir(e.deltaY < 0 ? 0.15 : -0.15);
  }

  lightboxCiftTiklandi() {
    if (this.lightboxZoom > 1) {
      this.lightboxZoom = 1; this.lightboxPanX = 0; this.lightboxPanY = 0;
    } else {
      this.lightboxZoom = 2.5;
    }
    this.CD.detectChanges();
  }

  lightboxPanBasla(e: MouseEvent) {
    if (this.lightboxZoom <= 1 || this.yuzEtiketModuAktif) return;
    e.preventDefault();
    this.lightboxSurukBilgi = { aktif: true, baslangicX: e.clientX, baslangicY: e.clientY, oncekiPanX: this.lightboxPanX, oncekiPanY: this.lightboxPanY };
    const tasiHandler = (ev: MouseEvent) => {
      if (!this.lightboxSurukBilgi?.aktif) return;
      this.lightboxPanX = this.lightboxSurukBilgi.oncekiPanX + (ev.clientX - this.lightboxSurukBilgi.baslangicX);
      this.lightboxPanY = this.lightboxSurukBilgi.oncekiPanY + (ev.clientY - this.lightboxSurukBilgi.baslangicY);
      this.CD.detectChanges();
    };
    const birakHandler = () => {
      this.lightboxSurukBilgi = null;
      this.document.removeEventListener('mousemove', tasiHandler);
      this.document.removeEventListener('mouseup', birakHandler);
    };
    this.document.addEventListener('mousemove', tasiHandler);
    this.document.addEventListener('mouseup', birakHandler);
  }

  lightboxResimYuklendi(e: Event) {
    const img = e.target as HTMLImageElement;
    const container = img.closest('.lightbox-resim-konteynir');
    if (!container) return;
    const cRect = container.getBoundingClientRect();
    const imgRect = img.getBoundingClientRect();
    this.lightboxResimAlani = {
      left: ((imgRect.left - cRect.left) / cRect.width) * 100,
      top: ((imgRect.top - cRect.top) / cRect.height) * 100,
      width: (imgRect.width / cRect.width) * 100,
      height: (imgRect.height / cRect.height) * 100,
    };
    this.CD.detectChanges();
  }

  lightboxKatmanTiklandi(e: MouseEvent) {
    if (!this.yuzEtiketModuAktif || this.bekleyenEtiket) return;
    const katman = e.currentTarget as HTMLElement;
    const rect = katman.getBoundingClientRect();
    const xPct = ((e.clientX - rect.left) / rect.width) * 100;
    const yPct = ((e.clientY - rect.top) / rect.height) * 100;
    const w = 12, h = 15;
    this.bekleyenEtiket = {
      x: Math.max(0, Math.min(100 - w, xPct - w / 2)),
      y: Math.max(0, Math.min(100 - h, yPct - h / 2)),
      w, h,
    };
    this.yuzEtiketAramaMetni = '';
    this.yuzEtiketAramaSonuclari = [];
    this.CD.detectChanges();
  }

  /** Sunucu limitiyle eşleşen istemci tarafı üst boyut (100 MB) */
  private static readonly MAX_DOSYA_BOYUTU = 100 * 1024 * 1024;

  secildiDosya($event: any) { // called each time file input changes
    // console.log("aloo",$event)
    // console.log($event)
    if ($event.target.files && $event.target.files[0]) {
      const dosya: File = $event.target.files[0]

      if (!dosya.type.startsWith("image") && dosya.size > PaylasIcerikEditorComponent.MAX_DOSYA_BOYUTU) {
        this.nzMessage.error('Dosya çok büyük (en fazla 100 MB)');
        $event.target.value = '';
        this.CD.detectChanges();
        return;
      }

      if (dosya.type.startsWith("image")) {
        this.icerik.ek = this.resimEkle(dosya);
      } else if (dosya.type.startsWith("video")) {
        this.icerik.ek = this.videoEkle(dosya);
      } else if (dosya.type.startsWith("audio")) {
        this.icerik.ek = this.sesEkle(dosya);
      } else {
        if (dosya.name.endsWith(".FikoGL"))
          this.icerik.ek = this.fikoGLEkle(dosya)
        else if (dosya.name.endsWith(".FikoGLS"))
          this.icerik.ek = this.fikoGLSEkle(dosya)
        else if (dosya.name.endsWith(".FikoOpGL"))
          this.icerik.ek = this.fikoOpGLEkle(dosya)
        else if (dosya.name.endsWith(".FikoOpGLv1"))
          this.icerik.ek = this.fikoOpGLv1Ekle(dosya)
        else
          this.icerik.ek = this.dosyaEkle(dosya);
      }

    }
    this.CD.detectChanges();
  }


  async resimSikistir(imageFile: any) {

    // console.log('originalFile instanceof Blob', imageFile instanceof Blob); // true
    // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

    var options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    }
    return imageCompression(imageFile, options)
  }

  resimEkle(dosya: File) {
    const ek: any = {};
    ek._id = this.FikoYT.fikoIdUret();
    ek.turu = IEkTuru.RESIM;
    ek.dosya = dosya;
    ek.dosyaObjectUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(dosya));
    ek.boyut = dosya.size;
    ek.ismi = dosya.name;
    ek.tipi = dosya.type;

    this.resimSikistir(dosya).then(compressedFile => {
      ek.orijinalBoyut = dosya.size;
      ek.dosya = compressedFile;
      ek.dosyaObjectUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(compressedFile));
      ek.boyut = compressedFile.size;
      this.CD.detectChanges();
      // Otomatik yüz tespiti başlat
      this.editorYuzTespitBaslat(ek._id, compressedFile);
    }).catch((e) => {
      console.warn('Resim sıkıştırma hatası:', e);
    });

    return ek;
  }

  videoEkle(dosya: File) {
    if (this.premiumKilit('video', 'Video Yükleme')) return null;
    // const reader = new FileReader();
    const ek: any = {};
    ek._id = this.FikoYT.fikoIdUret();
    ek.turu = IEkTuru.VIDEO;
    ek.dosya = dosya;
    ek.dosyaObjectUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(dosya));
    // reader.readAsDataURL(dosya); // read file as data url
    ek.boyut = dosya.size;
    ek.ismi = dosya.name;
    ek.tipi = dosya.type;

    return ek;
  }

  sesEkle(dosya: File) {
    // const reader = new FileReader();
    const ek: any = {};
    ek._id = this.FikoYT.fikoIdUret();
    ek.turu = IEkTuru.SES;
    ek.dosya = dosya;
    ek.dosyaObjectUrl = URL.createObjectURL(dosya);
    // reader.readAsDataURL(dosya); // read file as data url
    ek.boyut = dosya.size;
    ek.ismi = dosya.name;
    ek.tipi = dosya.type;

    return ek;
  }

  dosyaEkle(dosya: File) {
    // const reader = new FileReader();
    const ek: any = {};
    ek._id = this.FikoYT.fikoIdUret();
    ek.turu = IEkTuru.DOSYA;
    ek.dosya = dosya;
    ek.dosyaObjectUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(dosya));
    // reader.readAsDataURL(dosya); // read file as data url
    ek.boyut = dosya.size;
    ek.ismi = dosya.name;
    ek.tipi = dosya.type;

    return ek;
  }

  fikoGLEkle(dosya: File) {
    // const reader = new FileReader();
    const ek: any = {};
    ek._id = this.FikoYT.fikoIdUret();
    ek.turu = IEkTuru.FIKOGL;
    ek.dosya = dosya;
    ek.dosyaObjectUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(dosya));
    // reader.readAsDataURL(dosya); // read file as data url
    ek.boyut = dosya.size;
    ek.ismi = dosya.name;
    ek.tipi = dosya.type;

    return ek;
  }

  fikoGLSEkle(dosya: File) {
    // const reader = new FileReader();
    const ek: any = {};
    ek._id = this.FikoYT.fikoIdUret();
    ek.turu = IEkTuru.FIKOGLS;
    ek.dosya = dosya;
    ek.dosyaObjectUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(dosya));
    // reader.readAsDataURL(dosya); // read file as data url
    ek.boyut = dosya.size;
    ek.ismi = dosya.name;
    ek.tipi = dosya.type;

    return ek;
  }

  fikoOpGLEkle(dosya: File) {
    // const reader = new FileReader();
    const ek: any = {};
    ek._id = this.FikoYT.fikoIdUret();
    ek.turu = IEkTuru.FIKOOPGL;
    ek.dosya = dosya;
    ek.dosyaObjectUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(dosya));
    // reader.readAsDataURL(dosya); // read file as data url
    ek.boyut = dosya.size;
    ek.ismi = dosya.name;
    ek.tipi = dosya.type;

    return ek;
  }

  fikoOpGLv1Ekle(dosya: File) {
    // const reader = new FileReader();
    const ek: any = {};
    ek._id = this.FikoYT.fikoIdUret();
    ek.turu = IEkTuru.FIKOOPGLv1;
    ek.dosya = dosya;
    ek.dosyaObjectUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(dosya));
    // reader.readAsDataURL(dosya); // read file as data url
    ek.boyut = dosya.size;
    ek.ismi = dosya.name;
    ek.tipi = dosya.type;

    return ek;
  }


  /** 📢 premium özellik lisansı (köprü yoksa AÇIK — geriye uyumlu). */
  lisans(alt: string): boolean { try { return (window as any).__fikoLisans?.('📢', alt) ?? true; } catch { return true; } }
  /** Kilitliyse uyarı gösterip true döner (aksiyon engellenir). Açıksa kampanyalıysa bildirir. */
  private premiumKilit(alt: string, ad: string): boolean {
    if (this.lisans(alt)) { try { (window as any).__fikoKampanyaBildir?.('📢', alt, ad); } catch { } return false; }
    this.nzMessage?.warning(`"${ad}" özelliği lisansınızda yok. Fiyatlandırma sayfasından ekleyebilirsiniz.`);
    return true;
  }
  /** İçeriği şifrele (premium: icerik_sifre). */
  sifreKilitle() { if (this.premiumKilit('icerik_sifre', 'İçerik Şifre Kilidi')) return; this.icerik.sifre = ''; this.CD.detectChanges(); }
  /** Parametreli/dinamik uygulama içeriği ekle (premium: parametreli). */
  uygulamaIcerikEkle() { if (this.premiumKilit('parametreli', 'Parametreli İçerik')) return; this.icerik.ek = { turu: 'UYGULAMAICERIK', _id: '', parametreler: [] }; this.CD.detectChanges(); }
  /** Tasarım editörü modunu aç (premium: tasarim_editor). */
  tasarimModuAc() { if (this.premiumKilit('tasarim_editor', 'Tasarım Editörü')) return; this.tasarimModu = !this.tasarimModu; this.onizlemeModu = false; this.CD.detectChanges(); }
  /** Resimde yüz etiketleme modunu aç/kapat (premium: yuz_etiket). Kapatma her zaman serbest. */
  yuzEtiketModuToggle() {
    if (!this.yuzEtiketModuAktif && this.premiumKilit('yuz_etiket', 'Resimde Yüz Etiketleme')) return;
    this.yuzEtiketModuAktif = !this.yuzEtiketModuAktif; this.bekleyenEtiketIptal(); this.CD.detectChanges();
  }

  youtubeEkle(yid?: string) {
    if (this.premiumKilit('youtube', 'YouTube Video')) return null;

    const ek: any = {};
    ek._id = this.FikoYT.fikoIdUret();
    ek.turu = IEkTuru.YOUTUBE;
    ek.yid = yid;


    this.CD.detectChanges();
    setTimeout(() => {
      $('.ui.embed').embed({
        source: "youtube",
        brandedUI: true
      });
    }, 0);


    return ek;
  }

  async konumEkle() {
    if (this.premiumKilit('konum', 'Konum Paylaşımı')) return;
    const { HaritaYerSeciciComponent } = await import('@/src/app/uygulamalar/soyagaci/harita-yer-secici/harita-yer-secici.component');
    const modal = this.nzModalServis.create({
      nzTitle: 'Konum Seç',
      nzContent: HaritaYerSeciciComponent,
      nzWidth: 520,
      nzFooter: null,
      nzData: {},
    });
    modal.afterClose.subscribe((sonuc: any) => {
      if (sonuc?.yerIsmi) {
        const ek: any = {};
        ek._id = this.FikoYT.fikoIdUret();
        ek.turu = IEkTuru.KONUM;
        ek.ismi = sonuc.yerIsmi;
        ek.bilgiler = {
          yerIsmi: sonuc.yerIsmi,
          koordinat: sonuc.koordinat,
        };
        this.icerik.ek = ek;
        this.FikoYT.degisti.emit();
        this.CD.detectChanges();
        // @if bloğu renderlanana kadar bekle, sonra haritayı başlat
        setTimeout(() => this.konumHaritaBaslat(), 300);
      }
    });
  }

  async ekKonumSec() {
    const { HaritaYerSeciciComponent } = await import('@/src/app/uygulamalar/soyagaci/harita-yer-secici/harita-yer-secici.component');
    const modal = this.nzModalServis.create({
      nzTitle: 'Ek Konumu Seç',
      nzContent: HaritaYerSeciciComponent,
      nzWidth: 520,
      nzFooter: null,
      nzData: {
        mevcutYer: this.icerik?.ek?.konum?.yerIsmi || '',
        mevcutKoordinat: this.icerik?.ek?.konum?.koordinat || null,
      },
    });
    modal.afterClose.subscribe((sonuc: any) => {
      if (sonuc?.yerIsmi) {
        if (!this.icerik.ek.konum) this.icerik.ek.konum = {};
        this.icerik.ek.konum.yerIsmi = sonuc.yerIsmi;
        this.icerik.ek.konum.koordinat = sonuc.koordinat;
        this.FikoYT.degisti.emit();
        this.CD.detectChanges();
      }
    });
  }

  async konumDegistir() {
    const { HaritaYerSeciciComponent } = await import('@/src/app/uygulamalar/soyagaci/harita-yer-secici/harita-yer-secici.component');
    const modal = this.nzModalServis.create({
      nzTitle: 'Konumu Değiştir',
      nzContent: HaritaYerSeciciComponent,
      nzWidth: 520,
      nzFooter: null,
      nzData: {
        mevcutYer: this.icerik?.ek?.bilgiler?.yerIsmi || '',
        mevcutKoordinat: this.icerik?.ek?.bilgiler?.koordinat || null,
      },
    });
    modal.afterClose.subscribe((sonuc: any) => {
      if (sonuc?.yerIsmi) {
        this.icerik.ek.ismi = sonuc.yerIsmi;
        this.icerik.ek.bilgiler.yerIsmi = sonuc.yerIsmi;
        this.icerik.ek.bilgiler.koordinat = sonuc.koordinat;
        // Haritayı yeniden başlat
        this.konumHaritaAktifId = null;
        if (this.konumLeafletMap) {
          this.konumLeafletMap.remove();
          this.konumLeafletMap = null;
        }
        this.FikoYT.degisti.emit();
        this.CD.detectChanges();
        setTimeout(() => this.konumHaritaBaslat(), 300);
      }
    });
  }

  yapayZekaEkle(yid?: string) {
    if (this.premiumKilit('ai_gorsel', 'Yapay Zeka Görsel Üretimi')) return null;

    const ek: any = {};
    ek._id = this.FikoYT.fikoIdUret();
    ek.turu = IEkTuru.YAPAYZEKA;

    this.CD.detectChanges();
    return ek;
  }

  referansEkle(rid?: string) {

    const ek: any = {};
    ek._id = this.FikoYT.fikoIdUret();
    ek.turu = IEkTuru.REFERANS;
    ek.rid = rid;

    if (rid) {
      this.referansKartYukle(rid);
    }

    this.CD.detectChanges();
    return ek;
  }

  /** Referans kartı dinamik olarak FikoYTKartKokComponent ile yükler (circular dependency'yi önlemek için lazy import) */
  async referansKartYukle(rid: string) {
    if (!rid || this.referansKartYukleniyor) return;

    this.referansKartYukleniyor = true;
    this.CD.detectChanges();

    try {
      // Lazy import ile circular dependency'yi önle
      const { FikoYTKartKokComponent } = await import('../../../fikoyt-kart-kok/fikoyt-kart.component');

      // ViewContainerRef hazır olana kadar bekle (template render sonrası)
      let bekleme = 0;
      while (!this.referansKonteynir && bekleme < 10) {
        await new Promise<void>(resolve => setTimeout(resolve, 50));
        this.CD.detectChanges();
        bekleme++;
      }

      if (!this.referansKonteynir) {
        console.warn('referansKonteynir bulunamadı');
        this.referansKartYukleniyor = false;
        this.CD.detectChanges();
        return;
      }

      // Önceki bileşeni temizle
      this.referansKonteynir.clear();
      this.referansBilesenRef = null;

      // Dinamik olarak FikoYTKartKokComponent oluştur
      this.referansBilesenRef = this.referansKonteynir.createComponent(FikoYTKartKokComponent);
      // InputSignal için setInput kullan
      this.referansBilesenRef.setInput('kart', { _id: rid } as any);

      // API'den tam kart verisini çek
      const istek = new FikoYTIstekKok({
        metod: 'POST',
        komut: 'FikoYT.sistem.DB.hareketler.aggregate',
        gecikmeliCevap: false,
      });

      istek.parametreler = {
        aggregate: [
          { $match: { _id: rid } },
          {
            $lookup: {
              from: "hareketler",
              localField: "veri.icerikler",
              foreignField: "_id",
              as: "veri.icerikler"
            }
          },
          { $limit: 1 }
        ]
      };

      await istek.isteSync();

      if (istek.cevap?.sonuc?.length > 0) {
        const kartVeri = istek.cevap.sonuc[0];
        this.referansBilesenRef.setInput('kart', kartVeri);
      }
    } catch (e) {
      console.warn('Referans kart yükleme hatası:', e);
    }

    this.referansKartYukleniyor = false;
    this.CD.detectChanges();
  }

  uyarEkle(rid?: string) {
    if (this.premiumKilit('firma_custom_kart', 'Firmaya Özel Custom Kartlar')) return null;

    const ek: any = {};
    ek._id = this.FikoYT.fikoIdUret();
    ek.turu = IEkTuru.UYARDOKUM;
    ek.rid = rid;

    this.CD.detectChanges();
    $('.ui.embed').embed({
      source: "youtube",
      brandedUI: true
    });

    return ek;
  }


  // Mikrofon - tıkla başla / tıkla durdur
  async mikrofonTiklandi() {
    if (this.mikrofonKayitAktif) {
      this.mikrofonDurdur();
      return;
    }
    if (this.premiumKilit('ses_kayit', 'Ses Kaydı')) return;

    try {
      this.kayitStream = await navigator.mediaDevices.getUserMedia({ audio: true });
      this.kayitParcalari = [];
      this.kayitBlob = null;
      this.onizlemeTemizle();

      const mimeType = MediaRecorder.isTypeSupported('audio/webm;codecs=opus')
        ? 'audio/webm;codecs=opus'
        : (MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm' : '');

      this.mediaRecorder = mimeType
        ? new MediaRecorder(this.kayitStream, { mimeType })
        : new MediaRecorder(this.kayitStream);

      this.mediaRecorder.ondataavailable = (e) => {
        if (e.data.size > 0) this.kayitParcalari.push(e.data);
      };

      this.mediaRecorder.onstop = () => {
        this.kayitBlob = new Blob(this.kayitParcalari, { type: this.mediaRecorder.mimeType || 'audio/webm' });
        this.kayitStream?.getTracks().forEach(t => t.stop());
        this.kayitStream = null;

        // Custom player: blob'dan Audio oluştur, süreyi timer'dan biliyoruz
        this.onizlemeAudio = new Audio(URL.createObjectURL(this.kayitBlob));
        this.onizlemeAudio.ontimeupdate = () => {
          if (this.onizlemeAudio && this.mikrofonSure > 0) {
            this.onizlemeIlerleme = (this.onizlemeAudio.currentTime / this.mikrofonSure) * 100;
            this.CD.detectChanges();
          }
        };
        this.onizlemeAudio.onended = () => {
          this.onizlemeOynuyor = false;
          this.onizlemeIlerleme = 0;
          this.CD.detectChanges();
        };

        this.mikrofonMenuGoster = true;
        this.CD.detectChanges();
      };

      this.mediaRecorder.start(250);
      this.mikrofonKayitAktif = true;
      this.mikrofonSure = 0;
      this.mikrofonMenuGoster = false;

      this.kayitTimer = setInterval(() => {
        this.mikrofonSure++;
        this.CD.detectChanges();
      }, 1000);

      this.CD.detectChanges();
    } catch (e) {
      console.error('Mikrofon erişimi hatası:', e);
      this.nzMessage.error('Mikrofon erişimi reddedildi');
    }
  }

  // Mikrofon - kaydı durdur
  mikrofonDurdur() {
    if (!this.mediaRecorder || this.mediaRecorder.state === 'inactive') return;

    clearInterval(this.kayitTimer);
    this.kayitTimer = null;
    this.mikrofonKayitAktif = false;
    this.mediaRecorder.stop();
    this.CD.detectChanges();
  }

  // Mikrofon - iptal
  mikrofonIptal() {
    clearInterval(this.kayitTimer);
    this.kayitTimer = null;
    this.mikrofonKayitAktif = false;

    if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
      this.mediaRecorder.stop();
    }
    this.kayitStream?.getTracks().forEach(t => t.stop());
    this.kayitStream = null;
    this.onizlemeTemizle();
    this.kayitBlob = null;
    this.mikrofonMenuGoster = false;
    this.CD.detectChanges();
  }

  // Ses dosyası olarak ekle
  mikrofonSesEkle() {
    if (!this.kayitBlob) return;

    const dosya = new File([this.kayitBlob], `ses-kayit-${Date.now()}.webm`, {
      type: this.kayitBlob.type || 'audio/webm'
    });
    this.icerik.ek = this.sesEkle(dosya);
    this.mikrofonTemizle();
    this.FikoYT.degisti.emit();
    this.CD.detectChanges();
  }

  // Whisper STT ortak çağrı - sonucu ek.transkript'e kaydeder
  private async whisperTranskript(blob: Blob): Promise<string> {
    // Eğer ek zaten transkript içeriyorsa tekrar Whisper'a gönderme
    if (this.icerik?.ek?.transkript) {
      return this.icerik.ek.transkript;
    }

    const formData = new FormData();
    formData.append('file', blob, 'ses-kayit.webm');
    formData.append('language', 'tr');

    const baseUrl = FikoYTEnvIstemci.adres.sunucuUrl;
    const sonuc = await fetch(`${baseUrl}/fapiv1/whisper/transkript`, {
      method: 'POST',
      body: formData,
    });

    if (!sonuc.ok) throw new Error('Yazıya çevirme başarısız');

    const cevap = await sonuc.json();
    console.log('[Whisper] Tam cevap:', JSON.stringify(cevap));
    const veri = cevap.sonuc || cevap;
    const metin = (veri?.text || '').trim();
    console.log('[Whisper] Çıkarılan metin:', metin, '| veri keys:', Object.keys(veri));

    // Transkripti ek objesine kaydet (MongoDB'ye gidecek)
    if (metin && this.icerik?.ek) {
      this.icerik.ek.transkript = metin;
    }

    return metin;
  }

  // Yazıya çevir (Whisper STT)
  async mikrofonYaziyaCevir() {
    if (!this.kayitBlob || this.whisperYukleniyor) return;
    if (this.premiumKilit('whisper', 'Sesi Yazıya Çevir')) return;

    this.whisperYukleniyor = true;
    this.CD.detectChanges();

    try {
      const metin = await this.whisperTranskript(this.kayitBlob);

      if (metin) {
        if (!this.icerik.html) this.icerik.html = '';
        this.icerik.html += (this.icerik.html ? ' ' : '') + metin;
        await this.transkriptKaydet();
        this.nzMessage.success('Ses yazıya çevrildi');
      } else {
        this.nzMessage.warning('Metin bulunamadı');
      }
    } catch (e) {
      this.nzMessage.error('Bağlantı hatası: ' + e.message);
    }

    this.whisperYukleniyor = false;
    this.mikrofonTemizle();
    this.FikoYT.degisti.emit();
    this.CD.detectChanges();
  }

  // İkisini birden yap: Hem ses ekle hem yazıya çevir
  async mikrofonIkisiBirden() {
    if (!this.kayitBlob) return;
    if (this.premiumKilit('whisper', 'Sesi Yazıya Çevir')) return;

    // Önce ses dosyasını ekle
    const dosya = new File([this.kayitBlob], `ses-kayit-${Date.now()}.webm`, {
      type: this.kayitBlob.type || 'audio/webm'
    });
    this.icerik.ek = this.sesEkle(dosya);
    this.CD.detectChanges();

    // Sonra yazıya çevir
    this.whisperYukleniyor = true;
    this.CD.detectChanges();

    try {
      const metin = await this.whisperTranskript(this.kayitBlob);

      if (metin) {
        if (!this.icerik.html) this.icerik.html = '';
        this.icerik.html += (this.icerik.html ? ' ' : '') + metin;
        await this.transkriptKaydet();
        this.nzMessage.success('Ses eklendi ve yazıya çevrildi');
      }
    } catch (e) {
      this.nzMessage.error('Yazıya çevirme hatası: ' + e.message);
    }

    this.whisperYukleniyor = false;
    this.mikrofonTemizle();
    this.FikoYT.degisti.emit();
    this.CD.detectChanges();
  }

  // Mevcut ses ekini Whisper'a gönder (kart görüntülenirken)
  async sesEkiTranskript() {
    console.log('[sesEkiTranskript] Başlıyor. dosya:', this.icerik?.ek?.dosya, '| dosya type:', typeof this.icerik?.ek?.dosya, '| _id:', this.icerik?._id, '| transkript:', this.icerik?.ek?.transkript);

    // Ses verisini al: File/Blob varsa direkt kullan, yoksa URL'den indir
    let sesBlob: Blob = null;
    if (this.icerik?.ek?.dosya instanceof Blob) {
      sesBlob = this.icerik.ek.dosya;
    } else if (this.icerik?.ek?.dosyaObjectUrl) {
      // Sunucudan ses dosyasını indir
      try {
        const url = typeof this.icerik.ek.dosyaObjectUrl === 'string'
          ? this.icerik.ek.dosyaObjectUrl
          : this.icerik.ek.dosyaObjectUrl?.changingThisBreaksApplicationSecurity || '';
        if (url) {
          console.log('[sesEkiTranskript] URL\'den indiriliyor:', url);
          const resp = await fetch(url);
          sesBlob = await resp.blob();
        }
      } catch (e) {
        console.warn('[sesEkiTranskript] URL\'den indirme hatası:', e);
      }
    }

    if (!sesBlob || this.whisperYukleniyor) {
      console.warn('[sesEkiTranskript] sesBlob yok veya zaten yükleniyor');
      return;
    }

    // Zaten transkript varsa tekrar gönderme
    if (this.icerik.ek.transkript) {
      this.nzMessage.info('Transkript zaten mevcut');
      return;
    }

    this.whisperYukleniyor = true;
    this.CD.detectChanges();

    try {
      const metin = await this.whisperTranskript(sesBlob);

      if (metin) {
        if (!this.icerik.html) this.icerik.html = '';
        this.icerik.html += (this.icerik.html ? ' ' : '') + metin;

        // Transkripti MongoDB'ye kaydet (içerik _id varsa güncelle)
        await this.transkriptKaydet();

        this.nzMessage.success('Ses yazıya çevrildi ve kaydedildi');
      } else {
        this.nzMessage.warning('Metin bulunamadı');
      }
    } catch (e) {
      this.nzMessage.error('Bağlantı hatası: ' + e.message);
    }

    this.whisperYukleniyor = false;
    this.FikoYT.degisti.emit();
    this.CD.detectChanges();
  }

  // Transkripti MongoDB'ye kaydet (dot notation ile sadece ek.transkript güncellenir, diğer ek alanları korunur)
  private async transkriptKaydet() {
    console.log('[TranskriptKaydet] Başlıyor. _id:', this.icerik?._id, '| transkript:', this.icerik?.ek?.transkript);
    if (!this.icerik?._id || !this.icerik?.ek?.transkript) {
      console.warn('[TranskriptKaydet] _id veya transkript yok, çıkılıyor');
      return;
    }

    try {
      const guncelleme: any = {
        _id: this.icerik._id,
        'ek.transkript': this.icerik.ek.transkript
      };
      console.log('[TranskriptKaydet] Gönderilecek:', JSON.stringify(guncelleme));

      const formData = new FormData();
      formData.append('req_body', JSON.stringify(guncelleme));

      const baseUrl = FikoYTEnvIstemci.adres.sunucuUrl;
      const sonuc = await fetch(`${baseUrl}/fapiv1/fikoyt.com.FikoYT.sistem.DB.hareketler.ekle`, {
        method: 'POST',
        body: formData,
      });

      const cevap = await sonuc.json();
      console.log('[TranskriptKaydet] Sunucu cevabı:', JSON.stringify(cevap));

      if (!sonuc.ok) {
        console.warn('Transkript kayıt HTTP hatası:', sonuc.status);
      }
    } catch (e) {
      console.warn('Transkript MongoDB kayıt hatası:', e);
    }
  }

  private mikrofonTemizle() {
    this.onizlemeTemizle();
    this.kayitBlob = null;
    this.mikrofonMenuGoster = false;
  }

  // Önizleme audio temizle
  private onizlemeTemizle() {
    if (this.onizlemeAudio) {
      this.onizlemeAudio.pause();
      if (this.onizlemeAudio.src) URL.revokeObjectURL(this.onizlemeAudio.src);
      this.onizlemeAudio = null;
    }
    this.onizlemeOynuyor = false;
    this.onizlemeIlerleme = 0;
  }

  // Önizleme oynat/durdur
  onizlemeOynatDurdur() {
    if (!this.onizlemeAudio) return;
    if (this.onizlemeOynuyor) {
      this.onizlemeAudio.pause();
      this.onizlemeOynuyor = false;
    } else {
      this.onizlemeAudio.play();
      this.onizlemeOynuyor = true;
    }
    this.CD.detectChanges();
  }

  // Önizleme çubuk tıklama (seek)
  onizlemeCubukTiklandi(event: MouseEvent) {
    if (!this.onizlemeAudio || this.mikrofonSure <= 0) return;
    const bar = event.currentTarget as HTMLElement;
    const rect = bar.getBoundingClientRect();
    const oran = (event.clientX - rect.left) / rect.width;
    this.onizlemeAudio.currentTime = oran * this.mikrofonSure;
    this.onizlemeIlerleme = oran * 100;
    this.CD.detectChanges();
  }

  // Mikrofon süresini formatlı göster
  mikrofonSureFormat(): string {
    const dk = Math.floor(this.mikrofonSure / 60);
    const sn = this.mikrofonSure % 60;
    return (dk < 10 ? '0' + dk : dk) + ':' + (sn < 10 ? '0' + sn : sn);
  }

  okunabilirBoyut(bytes: any) {
    var i = Math.floor(Math.log(bytes) / Math.log(1024)),
      sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    //@ts-ignore
    return (bytes / Math.pow(1024, i)).toFixed(3) * 1 + ' ' + sizes[i];
  }

  /**
   * 
   */
     tiklandiFikoGL(dosya: File, resimAktar = false) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['🧩', '💎'])
    );

    const wnd = window.open(url, '_blank');
    //@ts-ignore
    wnd.dosya = dosya;
    if (resimAktar) {
      //@ts-ignore
      wnd.resimFunc = (rsm: any) => {
        this.icerik.ek.resimid = this.FikoYT.fikoIdUret();
        this.icerik.ek.resim = rsm;
        this.icerik.ek.resimObjectUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(rsm));
        this.CD.detectChanges();
        this.FikoYT.degisti.emit();
        wnd?.close();
      };
    }

  }

    /** STP kartından çekilmiş görüntüyü içerik ekine bağlar.
   *  NOT: Dosya/yükleme paylaş akışına aittir — `kartDerinKopya` `ek.resim` blobunu
   *  (File/Blob) `dosyaHaritasi`'ne alır, ardından `ikart-kutusu.paylasTiklandi`'daki
   *  per-content `ekle`de `resimid` anahtarıyla GridFS'ye yazar. Burada ayrıca
   *  `ekle` yapmayı BÖLDÜRÜRÜZ: ayrıca bir upsert, içindeki `ek.dosya` (wrl/stp model
   *  File'ı) JSON.stringify'de kaybolup 3D model referansını DB'de bozar, kartın 3D
   *  olarak algılanmamasına yol açar. Sadece blob'u + resimid'yi oturur ve değişi
   *  yayarız; asıl yükleme paylaş sırasında tekrarlanır. */
  stpFotografYuklendi(blob: Blob, icerik: any) {
    const ek = icerik?.ek;
    if (!ek || !icerik?._id || !(blob instanceof Blob)) return;

    const resimid = this.FikoYT.fikoIdUret();
    ek.resimid = resimid;
    ek.resim = blob; // ← kartDerinKopya bununla paylaş upload'ı tetikler (resimid anahtarlı)
    ek.resimObjectUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
    this.CD.detectChanges();
    this.FikoYT.degisti.emit();
  }


  /** */
  tetiklendiYapistir(event: any) {
    event.preventDefault();
    const items = (event.clipboardData || event.originalEvent.clipboardData).items;

    for (const item of items) {
      if (item.type.indexOf('image') === 0) {
        let blob = null;
        blob = item.getAsFile();

        this.icerik.ek = this.resimEkle(blob)

        this.CD.detectChanges();
        event.preventDefault();
      } else /*if (item.type.indexOf('text/plain') === 0)*/ {
        item.getAsString((str: string) => {
          document.execCommand("insertHTML", false, str);
          event.preventDefault();
        });
      }
    }
  }
  /** */

  tetiklendiDrop(event: any) {
    event.preventDefault();
    const items = event.dataTransfer.files;

    // if (!this.icerik.ek) {
    //   this.icerik.splice(this.FikoYT.paylas.aktifIcerikNo, 1);
    // }

    for (const item of items) {
      if (item.type.indexOf('image') === 0) {
        let blob = null;
        blob = item;
        this.icerik.ek = this.resimEkle(blob);

        this.FikoYT.degisti.emit();
        this.CD.detectChanges();
        event.preventDefault();
      }
      else if (item.type.indexOf('video') === 0) {
        let blob = null;
        blob = item;
        this.icerik.ek = this.videoEkle(blob);

        this.FikoYT.degisti.emit();
        this.CD.detectChanges();
        event.preventDefault();
      } else if (item.type.indexOf('audio') === 0) {
        let blob = null;
        blob = item;
        this.icerik.ek = this.sesEkle(blob);

        this.FikoYT.degisti.emit();
        this.CD.detectChanges();
        event.preventDefault();
      }
      else if (item.name.endsWith('.FikoGL')) {
        // this.servisFikoSistem.ngZone.run(() => {
        let blob = null;
        blob = item;
        this.icerik.ek = this.fikoGLEkle(blob);

        this.FikoYT.degisti.emit();
        this.CD.detectChanges();
        event.preventDefault();
        /** */
      } else if (item.name.endsWith('.FikoGLS')) {
        // this.servisFikoSistem.ngZone.run(() => {
        let blob = null;
        blob = item;
        this.icerik.ek = this.fikoGLSEkle(blob);

        this.FikoYT.degisti.emit();
        this.CD.detectChanges();
        event.preventDefault();
        /** */
      } else if (item.name.endsWith('.FikoOpGL')) {
        // this.servisFikoSistem.ngZone.run(() => {
        let blob = null;
        blob = item;
        this.icerik.ek = this.fikoOpGLEkle(blob);

        this.FikoYT.degisti.emit();
        this.CD.detectChanges();
        event.preventDefault();
        /** */
      } else if (item.name.endsWith('.FikoOpGLv1')) {
        // this.servisFikoSistem.ngZone.run(() => {
        let blob = null;
        blob = item;
        this.icerik.ek = this.fikoOpGLv1Ekle(blob);

        this.FikoYT.degisti.emit();
        this.CD.detectChanges();
        event.preventDefault();
        /** */
      }
      else {
        let blob = null;
        blob = item;
        this.icerik.ek = this.dosyaEkle(blob);

        this.FikoYT.degisti.emit();
        this.CD.detectChanges();
        event.preventDefault();

      }
    }
    // this.FikoYT.paylas.aktifEtSonSayfa();
    this.FikoYT.degisti.emit();
    this.CD.detectChanges();
  }

  tiklandiPanodanYapistir() {
    try {
      //@ts-ignore
      navigator.clipboard.read().then((items: any) => {
        items.forEach((item: any) => {
          // console.log(item);
          // do something with the data item
        });
      });
    } catch (err: any) {
      // this.servisFikoSistem.mesaj.error('Yetki Hatası');
      console.error(err.name, err.message);
    }
  }
  /** */
  sonuc: any;

  /** Resim yüklendiğinde gerçek alanı hesapla */
  resimYuklendi($event: Event) {
    const img = $event.target as HTMLImageElement;
    this.sonResimEl = img;
    this.resimAlaniHesapla(img);
    // Container resize olduğunda yeniden hesapla
    if (this.resimAlaniObserver) this.resimAlaniObserver.disconnect();
    const container = img.parentElement;
    if (container) {
      this.resimAlaniObserver = new ResizeObserver(() => this.resimAlaniHesapla(img));
      this.resimAlaniObserver.observe(container);
    }
    // EKREFERANS resimler için otomatik yüz tespiti sorgula
    if (this.icerik?.ek?.turu === IEkTuru.EKREFERANS && this.icerik?.ek?._id) {
      this.editorYuzTespitEkRefSorgula(this.icerik.ek._id);
    }
  }

  /** Resmin container içindeki gerçek px alanını % olarak hesaplar (contain/cover her ikisini destekler) */
  private resimAlaniHesapla(img: HTMLImageElement) {
    if (!img?.naturalWidth || !img?.naturalHeight) return;
    const container = img.parentElement;
    if (!container) return;
    const cRect = container.getBoundingClientRect();
    const fit = getComputedStyle(img).objectFit || 'contain';
    const scale = fit === 'cover'
      ? Math.max(cRect.width / img.naturalWidth, cRect.height / img.naturalHeight)
      : Math.min(cRect.width / img.naturalWidth, cRect.height / img.naturalHeight);
    const rW = img.naturalWidth * scale;
    const rH = img.naturalHeight * scale;
    this.resimAlani = {
      left: ((cRect.width - rW) / 2 / cRect.width) * 100,
      top: ((cRect.height - rH) / 2 / cRect.height) * 100,
      width: (rW / cRect.width) * 100,
      height: (rH / cRect.height) * 100,
    };
    this.CD.detectChanges();
  }

  tiklandiSiniflandir($event: MouseEvent) {
    if (!this.yuzEtiketModuAktif) return;
    const img = $event.currentTarget as HTMLImageElement;
    // Gerçek resim alanı üzerinden koordinat hesapla
    const bounds = this.resimGercekBounds(img);
    if (!bounds) return;
    // Tıklama resim alanı dışındaysa yoksay
    if ($event.clientX < bounds.left || $event.clientX > bounds.left + bounds.width ||
        $event.clientY < bounds.top || $event.clientY > bounds.top + bounds.height) return;
    const xPct = (($event.clientX - bounds.left) / bounds.width) * 100;
    const yPct = (($event.clientY - bounds.top) / bounds.height) * 100;
    const w = 12, h = 15;
    this.bekleyenEtiket = {
      x: Math.max(0, Math.min(100 - w, xPct - w / 2)),
      y: Math.max(0, Math.min(100 - h, yPct - h / 2)),
      w, h,
    };
    this.yuzEtiketAramaMetni = '';
    this.yuzEtiketAramaSonuclari = [];
    this.CD.detectChanges();
  }

  /** Resmin container içindeki gerçek px bound'larını döndürür (contain/cover destekli) */
  private resimGercekBounds(img: HTMLImageElement): { left: number; top: number; width: number; height: number } | null {
    if (!img?.naturalWidth || !img?.naturalHeight) return null;
    const cRect = img.getBoundingClientRect();
    const fit = getComputedStyle(img).objectFit || 'contain';
    const scale = fit === 'cover'
      ? Math.max(cRect.width / img.naturalWidth, cRect.height / img.naturalHeight)
      : Math.min(cRect.width / img.naturalWidth, cRect.height / img.naturalHeight);
    const rW = img.naturalWidth * scale;
    const rH = img.naturalHeight * scale;
    return {
      left: cRect.left + (cRect.width - rW) / 2,
      top: cRect.top + (cRect.height - rH) / 2,
      width: rW,
      height: rH,
    };
  }

  yuzEtiketAra(metin: string) {
    this.yuzEtiketAramaMetni = metin;
    if (this.yuzEtiketAramaTimer) clearTimeout(this.yuzEtiketAramaTimer);
    if (!metin || metin.length < 2) {
      this.yuzEtiketAramaSonuclari = [];
      this.CD.detectChanges();
      return;
    }
    this.yuzEtiketAramaTimer = setTimeout(async () => {
      try {
        // 1) Platform kullanıcıları ara
        const istek = new FikoYTIstekKok({
          metod: 'POST',
          komut: 'FikoYT.sistem.DB.goUyeler.aggregate',
        });
        istek.parametreler = {
          aggregate: [
            { $match: { 'veri.pilesmi': { $regex: escapeRegex(metin), $options: 'i' } } },
            { $limit: 8 },
            { $project: { _id: 1, 'veri.pilesmi': 1 } }
          ]
        };
        await istek.isteSync();
        const platformSonuc = (istek.cevap?.sonuc || []).map((k: any) => ({
          _id: k._id,
          ismi: k.veri?.pilesmi || k._id,
          kaynak: 'platform',
        }));

        // 2) Soyağacı kişilerini ara (kart bağlamında soyağacı varsa)
        let soyagaciSonuc: any[] = [];
        try {
          const soyIstek = new FikoYTIstekKok({
            metod: 'POST',
            komut: 'FikoYT.sistem.DB.hareketler.aggregate',
          });
          soyIstek.parametreler = {
            aggregate: [
              { $match: {
                vt: 'FikoYT.sistem.soyAgaciKisiler',
                silindi: { $ne: true },
                $or: [
                  { 'veri.isim': { $regex: escapeRegex(metin), $options: 'i' } },
                  { 'veri.soyIsim': { $regex: escapeRegex(metin), $options: 'i' } },
                ]
              }},
              { $limit: 8 },
              { $project: { _id: 1, 'veri.isim': 1, 'veri.soyIsim': 1, 'veri.resimUrl': 1 } }
            ]
          };
          await soyIstek.isteSync();
          soyagaciSonuc = (soyIstek.cevap?.sonuc || []).map((k: any) => ({
            _id: 'soyagaci:' + k._id,
            soyagaciKisiId: k._id,
            ismi: ((k.veri?.isim || '') + ' ' + (k.veri?.soyIsim || '')).trim(),
            resimUrl: k.veri?.resimUrl,
            kaynak: 'soyagaci',
          }));
        } catch (e) {}

        this.yuzEtiketAramaSonuclari = [...soyagaciSonuc, ...platformSonuc];
      } catch (e) {
        this.yuzEtiketAramaSonuclari = [];
      }
      this.CD.detectChanges();
    }, 300);
  }

  bekleyenEtiketIptal() {
    this.bekleyenEtiket = null;
    this.yuzEtiketAramaMetni = '';
    this.yuzEtiketAramaSonuclari = [];
    this.CD.detectChanges();
  }

  yuzEtiketEkle(kisi?: { _id?: string; ismi: string; kaynak?: string; soyagaciKisiId?: string; resimUrl?: string }) {
    if (!this.bekleyenEtiket || !this.icerik?.ek) return;
    if (!this.icerik.ek.yuzEtiketleri) this.icerik.ek.yuzEtiketleri = [];
    const etiket: IYuzEtiketi = {
      id: this.FikoYT.fikoIdUret(),
      x: this.bekleyenEtiket.x,
      y: this.bekleyenEtiket.y,
      w: this.bekleyenEtiket.w,
      h: this.bekleyenEtiket.h,
      kisiIsmi: kisi?.ismi || this.yuzEtiketAramaMetni,
      kisiId: kisi?.kaynak === 'platform' ? kisi._id : (kisi?._id && !kisi?.soyagaciKisiId ? kisi._id : undefined),
      soyagaciKisiId: kisi?.soyagaciKisiId || undefined,
    };
    this.icerik.ek.yuzEtiketleri.push(etiket);
    this.bekleyenEtiket = null;
    this.yuzEtiketAramaMetni = '';
    this.yuzEtiketAramaSonuclari = [];
    this.yuzEtiketleriKaydet();
    this.CD.detectChanges();
  }

  yuzEtiketSil(id: string) {
    if (!this.icerik?.ek?.yuzEtiketleri) return;
    this.icerik.ek.yuzEtiketleri = this.icerik.ek.yuzEtiketleri.filter((e: IYuzEtiketi) => e.id !== id);
    this.yuzEtiketleriKaydet();
    this.CD.detectChanges();
  }

  // Etiket isim düzenleme
  duzenlenenEtiketId: string | null = null;
  duzenlenenEtiketIsmi = '';
  acikBalonEtiketId: string | null = null;

  get acikBalonEtiket(): IYuzEtiketi | null {
    if (!this.acikBalonEtiketId) return null;
    return this.icerik?.ek?.yuzEtiketleri?.find((e: IYuzEtiketi) => e.id === this.acikBalonEtiketId) || null;
  }

  /** Düzenlenen etiketin % pozisyonu */
  get duzenlenenEtiketPozisyon(): { x: number; y: number } | null {
    if (!this.duzenlenenEtiketId) return null;
    const etiket = this.icerik?.ek?.yuzEtiketleri?.find((e: IYuzEtiketi) => e.id === this.duzenlenenEtiketId);
    if (!etiket) return null;
    return { x: etiket.x + etiket.w / 2, y: etiket.y + etiket.h };
  }

  popoverGorunurlukDegisti(gorunur: boolean, etiket: IYuzEtiketi) {
    if (!gorunur && (this.acikBalonEtiketId === etiket.id || this.duzenlenenEtiketId === etiket.id)) {
      this.acikBalonEtiketId = null;
      this.duzenlenenEtiketId = null;
      this.CD.detectChanges();
    }
  }

  etiketTiklandi(etiket: IYuzEtiketi) {
    if (this.yuzEtiketModuAktif) {
      this.yuzEtiketDuzenleBasla(etiket);
    } else {
      this.acikBalonEtiketId = this.acikBalonEtiketId === etiket.id ? null : etiket.id;
    }
    this.CD.detectChanges();
  }

  yuzEtiketDuzenleBasla(etiket: IYuzEtiketi) {
    this.duzenlenenEtiketId = etiket.id;
    this.duzenlenenEtiketIsmi = etiket.kisiIsmi;
    this.yuzEtiketAramaMetni = etiket.kisiIsmi;
    this.yuzEtiketAramaSonuclari = [];
    this.CD.detectChanges();
  }

  yuzEtiketDuzenleKaydet(kisi?: { _id?: string; ismi: string; kaynak?: string; soyagaciKisiId?: string }) {
    if (!this.duzenlenenEtiketId) return;
    const etiket = this.icerik?.ek?.yuzEtiketleri?.find((e: IYuzEtiketi) => e.id === this.duzenlenenEtiketId);
    if (!etiket) return;
    etiket.kisiIsmi = kisi?.ismi || this.duzenlenenEtiketIsmi;
    etiket.kisiId = kisi?.kaynak === 'platform' ? kisi._id : (kisi?._id && !kisi?.soyagaciKisiId ? kisi._id : etiket.kisiId);
    etiket.soyagaciKisiId = kisi?.soyagaciKisiId || etiket.soyagaciKisiId;
    this.duzenlenenEtiketId = null;
    this.duzenlenenEtiketIsmi = '';
    this.yuzEtiketAramaMetni = '';
    this.yuzEtiketAramaSonuclari = [];
    this.yuzEtiketleriKaydet();
    this.CD.detectChanges();
  }

  yuzEtiketDuzenleIptal() {
    this.duzenlenenEtiketId = null;
    this.duzenlenenEtiketIsmi = '';
    this.yuzEtiketAramaMetni = '';
    this.yuzEtiketAramaSonuclari = [];
    this.CD.detectChanges();
  }

  // Katman üzerine tıklama — yeni etiket ekle
  katmanTiklandi($event: MouseEvent) {
    if (!this.yuzEtiketModuAktif) return;
    // Zaten bekleyen çerçeve varsa tekrar oluşturma
    if (this.bekleyenEtiket) return;
    $event.stopPropagation();
    const katman = ($event.currentTarget as HTMLElement);
    const rect = katman.getBoundingClientRect();
    const xPct = (($event.clientX - rect.left) / rect.width) * 100;
    const yPct = (($event.clientY - rect.top) / rect.height) * 100;
    const w = 12, h = 15;
    this.bekleyenEtiket = {
      x: Math.max(0, Math.min(100 - w, xPct - w / 2)),
      y: Math.max(0, Math.min(100 - h, yPct - h / 2)),
      w, h,
    };
    this.yuzEtiketAramaMetni = '';
    this.yuzEtiketAramaSonuclari = [];
    this.CD.detectChanges();
  }

  yuzEtiketGosterimDegistir() {
    if (!this.icerik?.ek) return;
    const modlar: Array<'hover' | 'surekli' | 'liste' | 'kapali'> = ['hover', 'surekli', 'liste', 'kapali'];
    const mevcut = this.icerik.ek.yuzEtiketGosterim || 'hover';
    const idx = modlar.indexOf(mevcut as any);
    this.icerik.ek.yuzEtiketGosterim = modlar[(idx + 1) % modlar.length];
    this.yuzEtiketleriKaydet();
    this.CD.detectChanges();
  }

  // Çerçeve taşıma (drag to move)
  cerceveTasimaBasla($event: MouseEvent, etiketId: string) {
    $event.preventDefault();
    $event.stopPropagation();
    const etiket = this.icerik?.ek?.yuzEtiketleri?.find((e: IYuzEtiketi) => e.id === etiketId);
    if (!etiket) return;
    const startX = $event.clientX;
    const startY = $event.clientY;
    const baslangic = { x: etiket.x, y: etiket.y };
    const mousemove = (e: MouseEvent) => {
      const katman = this.katmanBoyutAl();
      if (!katman) return;
      const dx = ((e.clientX - startX) / katman.width) * 100;
      const dy = ((e.clientY - startY) / katman.height) * 100;
      etiket.x = Math.max(0, Math.min(100 - etiket.w, baslangic.x + dx));
      etiket.y = Math.max(0, Math.min(100 - etiket.h, baslangic.y + dy));
      this.CD.detectChanges();
    };
    const mouseup = () => {
      document.removeEventListener('mousemove', mousemove);
      document.removeEventListener('mouseup', mouseup);
      this.yuzEtiketleriKaydet();
    };
    document.addEventListener('mousemove', mousemove);
    document.addEventListener('mouseup', mouseup);
  }

  // Çerçeve boyutlandırma - mousedown başlat
  cerceveBoyutlandirBasla($event: MouseEvent, etiketId: string, yon: string) {
    $event.preventDefault();
    $event.stopPropagation();
    const etiket = this.icerik?.ek?.yuzEtiketleri?.find((e: IYuzEtiketi) => e.id === etiketId);
    if (!etiket) return;
    this.suruklenenEtiketId = etiketId;
    this.suruklemeBilgi = {
      yon,
      baslangicX: $event.clientX,
      baslangicY: $event.clientY,
      baslangicRect: { x: etiket.x, y: etiket.y, w: etiket.w, h: etiket.h },
    };
    const mousemove = (e: MouseEvent) => this.cerceveBoyutlandirDevam(e);
    const mouseup = () => {
      document.removeEventListener('mousemove', mousemove);
      document.removeEventListener('mouseup', mouseup);
      this.suruklenenEtiketId = null;
      this.suruklemeBilgi = null;
      this.yuzEtiketleriKaydet();
    };
    document.addEventListener('mousemove', mousemove);
    document.addEventListener('mouseup', mouseup);
  }

  /** Katman div'inin px boyutunu alır (gerçek resim alanı) */
  private katmanBoyutAl(): { width: number; height: number } | null {
    if (!this.resimAlani || !this.sonResimEl) return null;
    const cRect = this.sonResimEl.parentElement?.getBoundingClientRect();
    if (!cRect) return null;
    return {
      width: cRect.width * this.resimAlani.width / 100,
      height: cRect.height * this.resimAlani.height / 100,
    };
  }

  private cerceveBoyutlandirDevam(e: MouseEvent) {
    if (!this.suruklemeBilgi || !this.suruklenenEtiketId) return;
    const etiket = this.icerik?.ek?.yuzEtiketleri?.find((et: IYuzEtiketi) => et.id === this.suruklenenEtiketId);
    if (!etiket) return;
    const katman = this.katmanBoyutAl();
    if (!katman) return;
    const dx = ((e.clientX - this.suruklemeBilgi.baslangicX) / katman.width) * 100;
    const dy = ((e.clientY - this.suruklemeBilgi.baslangicY) / katman.height) * 100;
    const b = this.suruklemeBilgi.baslangicRect;
    const yon = this.suruklemeBilgi.yon;
    const min = 5;

    if (yon.includes('e')) { etiket.w = Math.max(min, Math.min(100 - b.x, b.w + dx)); }
    if (yon.includes('w')) { etiket.x = Math.min(b.x + b.w - min, b.x + dx); etiket.w = Math.max(min, b.w - dx); }
    if (yon.includes('s')) { etiket.h = Math.max(min, Math.min(100 - b.y, b.h + dy)); }
    if (yon.includes('n')) { etiket.y = Math.min(b.y + b.h - min, b.y + dy); etiket.h = Math.max(min, b.h - dy); }
    this.CD.detectChanges();
  }

  bekleyenCerceveTasimaBasla($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    if (!this.bekleyenEtiket) return;
    const startX = $event.clientX;
    const startY = $event.clientY;
    const baslangic = { x: this.bekleyenEtiket.x, y: this.bekleyenEtiket.y };
    const mousemove = (e: MouseEvent) => {
      const katman = this.katmanBoyutAl();
      if (!katman || !this.bekleyenEtiket) return;
      const dx = ((e.clientX - startX) / katman.width) * 100;
      const dy = ((e.clientY - startY) / katman.height) * 100;
      this.bekleyenEtiket.x = Math.max(0, Math.min(100 - this.bekleyenEtiket.w, baslangic.x + dx));
      this.bekleyenEtiket.y = Math.max(0, Math.min(100 - this.bekleyenEtiket.h, baslangic.y + dy));
      this.CD.detectChanges();
    };
    const mouseup = () => {
      document.removeEventListener('mousemove', mousemove);
      document.removeEventListener('mouseup', mouseup);
    };
    document.addEventListener('mousemove', mousemove);
    document.addEventListener('mouseup', mouseup);
  }

  bekleyenCerceveBoyutlandirBasla($event: MouseEvent, yon: string) {
    $event.preventDefault();
    $event.stopPropagation();
    if (!this.bekleyenEtiket) return;
    const baslangic = { ...this.bekleyenEtiket };
    const startX = $event.clientX;
    const startY = $event.clientY;
    const mousemove = (e: MouseEvent) => {
      const katman = this.katmanBoyutAl();
      if (!katman || !this.bekleyenEtiket) return;
      const dx = ((e.clientX - startX) / katman.width) * 100;
      const dy = ((e.clientY - startY) / katman.height) * 100;
      const min = 5;
      if (yon.includes('e')) { this.bekleyenEtiket.w = Math.max(min, Math.min(100 - baslangic.x, baslangic.w + dx)); }
      if (yon.includes('w')) { this.bekleyenEtiket.x = Math.min(baslangic.x + baslangic.w - min, baslangic.x + dx); this.bekleyenEtiket.w = Math.max(min, baslangic.w - dx); }
      if (yon.includes('s')) { this.bekleyenEtiket.h = Math.max(min, Math.min(100 - baslangic.y, baslangic.h + dy)); }
      if (yon.includes('n')) { this.bekleyenEtiket.y = Math.min(baslangic.y + baslangic.h - min, baslangic.y + dy); this.bekleyenEtiket.h = Math.max(min, baslangic.h - dy); }
      this.CD.detectChanges();
    };
    const mouseup = () => {
      document.removeEventListener('mousemove', mousemove);
      document.removeEventListener('mouseup', mouseup);
    };
    document.addEventListener('mousemove', mousemove);
    document.addEventListener('mouseup', mouseup);
  }

  // ─── Otomatik Yüz Tespiti (Editör Modunda) ─────────────────────────────

  /** Editörde resim eklendiğinde sunucuya yükleyip yüz tespiti başlatır */
  private async editorYuzTespitBaslat(ekId: string, dosya: File | Blob) {
    this.editorYuzTespitYukleniyor = true;
    this.editorOtomatikYuzler = [];
    this.editorYuzTespitEkId = ekId;
    this.CD.detectChanges();

    try {
      const baseUrl = FikoYTEnvIstemci.adres.sunucuUrl;

      // 1. Resmi sunucuya yükle (hareketler koleksiyonuna geçici dosya olarak)
      const formData = new FormData();
      formData.append('req_body', JSON.stringify({ _id: ekId, gecici: true, vt: 'FikoYT.sistem.geciciDosyalar' }));
      formData.append(ekId, dosya, 'face_detect.jpg');
      await fetch(`${baseUrl}/fapiv1/fikoyt.com.FikoYT.sistem.DB.hareketler.ekle`, {
        method: 'POST',
        body: formData,
      });

      // 2. Yüz tanıma kuyruğuna ekle (yüksek öncelik)
      const kuyrukFormData = new FormData();
      kuyrukFormData.append('req_body', JSON.stringify({
        resim_id: ekId,
        icerik_id: ekId,
        durum: 'bekliyor',
        oncelik: 100,
        tarih: new Date(),
        deneme: 0,
        gecici: true,
      }));
      await fetch(`${baseUrl}/fapiv1/fikoyt.com.FikoYT.sistem.DB.yuz_kuyruk.ekle`, {
        method: 'POST',
        body: kuyrukFormData,
      });

      // 3. Sonuçları bekle ve sorgula
      this.editorYuzTespitSorgula(ekId, 0);
    } catch (e) {
      console.warn('Yüz tespiti başlatma hatası:', e);
      this.editorYuzTespitYukleniyor = false;
      this.CD.detectChanges();
    }
  }

  /** EKREFERANS resimler için mevcut yüz tespitlerini sorgula */
  private async editorYuzTespitEkRefSorgula(ekId: string) {
    this.editorYuzTespitEkId = ekId;
    this.editorYuzTespitSorgula(ekId, 0);
  }

  /** yuz_tespit koleksiyonunu polling ile sorgular */
  private async editorYuzTespitSorgula(ekId: string, denemeSayisi: number) {
    if (this.editorYuzTespitTimer) clearTimeout(this.editorYuzTespitTimer);
    // EkId değiştiyse (yeni resim eklendi) eski sorguyu iptal et
    if (this.editorYuzTespitEkId !== ekId) return;

    try {
      const istek = new FikoYTIstekKok({
        metod: 'POST',
        komut: 'FikoYT.sistem.DB.yuz_tespit.aggregate',
      });
      istek.parametreler = {
        aggregate: [
          { $match: { icerik_id: ekId } },
          { $limit: 1 },
        ],
      };
      await istek.isteSync();

      const sonuclar = istek.cevap?.sonuc;
      if (!sonuclar?.length) {
        // Henüz işlenmemiş - tekrar dene (max 10 deneme / ~30sn)
        if (denemeSayisi < 10) {
          this.editorYuzTespitTimer = setTimeout(() => this.editorYuzTespitSorgula(ekId, denemeSayisi + 1), 3000);
        } else {
          this.editorYuzTespitYukleniyor = false;
          this.CD.detectChanges();
        }
        return;
      }

      const tespit = sonuclar[0];
      this.editorYuzTespitYukleniyor = false;

      if (!tespit?.yuzler?.length) {
        this.editorOtomatikYuzler = [];
        this.CD.detectChanges();
        return;
      }

      // Mevcut etiketlerle çakışanları filtrele
      const mevcutKisiKimlikleri = new Set(
        (this.icerik?.ek?.yuzEtiketleri || [])
          .map((e: IYuzEtiketi) => e.soyagaciKisiId || e.kisiId || e.kisiIsmi)
          .filter(Boolean)
      );
      const mevcutPozisyonlar = (this.icerik?.ek?.yuzEtiketleri || []).map((e: IYuzEtiketi) => ({
        cx: e.x + e.w / 2, cy: e.y + e.h / 2
      }));

      this.editorOtomatikYuzler = tespit.yuzler
        .filter((y: any) => {
          if (y.onaylandi) return false;
          if (y.eslesmeler?.length > 0) {
            const enYakin = y.eslesmeler[0];
            if (mevcutKisiKimlikleri.has(enYakin.kisi_id) || mevcutKisiKimlikleri.has(enYakin.ad)) return false;
          }
          const yCx = y.x + y.w / 2, yCy = y.y + y.h / 2;
          for (const p of mevcutPozisyonlar) {
            if (Math.abs(yCx - p.cx) < 8 && Math.abs(yCy - p.cy) < 8) return false;
          }
          return true;
        })
        .map((y: any) => ({
          ...y,
          enYakinEslesme: y.eslesmeler?.length > 0 ? y.eslesmeler[0] : null,
        }));

      this.CD.detectChanges();
    } catch (e) {
      this.editorYuzTespitYukleniyor = false;
      this.CD.detectChanges();
    }
  }

  /** Otomatik tespit edilen yüzü onayla */
  editorOtomatikYuzOnayla(yuzIdx: number, kisi?: { _id?: string; ismi: string; kaynak?: string; soyagaciKisiId?: string; resimUrl?: string }) {
    const yuz = this.editorOtomatikYuzler[yuzIdx];
    if (!yuz || !this.icerik?.ek) return;
    if (!this.icerik.ek.yuzEtiketleri) this.icerik.ek.yuzEtiketleri = [];

    const etiket: IYuzEtiketi = {
      id: yuz.id || Date.now().toString(36) + Math.random().toString(36).slice(2, 6),
      x: yuz.x,
      y: yuz.y,
      w: yuz.w,
      h: yuz.h,
      kisiIsmi: kisi?.ismi || yuz.enYakinEslesme?.ad || this.editorOtomatikYuzAramaMetni || 'Bilinmeyen',
      kisiId: kisi?.kaynak === 'platform' ? kisi._id : (yuz.enYakinEslesme?.kisi_id || undefined),
      soyagaciKisiId: kisi?.soyagaciKisiId || undefined,
      resimUrl: kisi?.resimUrl || yuz.enYakinEslesme?.resim_url || undefined,
    };

    this.icerik.ek.yuzEtiketleri.push(etiket);
    this.editorOtomatikYuzler.splice(yuzIdx, 1);
    this.editorOtomatikYuzAktifIdx = null;
    this.editorOtomatikYuzAramaMetni = '';
    this.editorOtomatikYuzAramaSonuclari = [];

    // Tanınan kişi descriptor'ını kaydet
    if (yuz.descriptor?.length && etiket.kisiIsmi) {
      this.editorOtomatikYuzTaninanKaydet(etiket, yuz.descriptor);
    }

    this.CD.detectChanges();
  }

  /** Otomatik tespit edilen yüzü reddet */
  editorOtomatikYuzReddet(yuzIdx: number) {
    this.editorOtomatikYuzler.splice(yuzIdx, 1);
    this.editorOtomatikYuzAktifIdx = null;
    this.CD.detectChanges();
  }

  /** En yakın eşleşmeyi hızlı onayla (tek tıkla) */
  editorOtomatikYuzHizliOnayla(yuzIdx: number) {
    const yuz = this.editorOtomatikYuzler[yuzIdx];
    if (!yuz?.enYakinEslesme) return;
    this.editorOtomatikYuzOnayla(yuzIdx, {
      ismi: yuz.enYakinEslesme.ad,
      _id: yuz.enYakinEslesme.kisi_id,
    });
  }

  /** Otomatik yüz için kişi arama */
  editorOtomatikYuzAra(metin: string) {
    this.editorOtomatikYuzAramaMetni = metin;
    if (this.editorOtomatikYuzAramaTimer) clearTimeout(this.editorOtomatikYuzAramaTimer);
    if (!metin || metin.length < 2) {
      this.editorOtomatikYuzAramaSonuclari = [];
      this.CD.detectChanges();
      return;
    }
    this.editorOtomatikYuzAramaTimer = setTimeout(() => {
      this.yuzEtiketAra(metin);
      setTimeout(() => {
        this.editorOtomatikYuzAramaSonuclari = [...this.yuzEtiketAramaSonuclari];
        this.CD.detectChanges();
      }, 400);
    }, 300);
  }

  /** Onaylanan yüzün descriptor'ını yuz_taninan'a kaydet */
  private async editorOtomatikYuzTaninanKaydet(etiket: IYuzEtiketi, descriptor: number[]) {
    try {
      const baseUrl = FikoYTEnvIstemci.adres.sunucuUrl;
      const kisiId = etiket.kisiId || etiket.soyagaciKisiId || etiket.id;

      const formData = new FormData();
      formData.append('req_body', JSON.stringify({
        kisi_id: kisiId,
        ad: etiket.kisiIsmi,
        ortalama_descriptor: descriptor,
        foto_sayisi: 1,
        tarih: new Date(),
      }));
      await fetch(`${baseUrl}/fapiv1/fikoyt.com.FikoYT.sistem.DB.yuz_taninan.ekle`, {
        method: 'POST',
        body: formData,
      });
    } catch (e) {
      console.warn('Tanınan kişi kayıt hatası:', e);
    }
  }

  private async yuzEtiketleriKaydet() {
    if (!this.icerik?._id) return;
    try {
      const guncelleme: any = {
        _id: this.icerik._id,
        'ek.yuzEtiketleri': this.icerik.ek.yuzEtiketleri || [],
        'ek.yuzEtiketGosterim': this.icerik.ek.yuzEtiketGosterim || 'hover',
      };
      const formData = new FormData();
      formData.append('req_body', JSON.stringify(guncelleme));
      const baseUrl = FikoYTEnvIstemci.adres.sunucuUrl;
      await fetch(`${baseUrl}/fapiv1/fikoyt.com.FikoYT.sistem.DB.hareketler.ekle`, {
        method: 'POST',
        body: formData,
      });
    } catch (e) {
      console.warn('Yüz etiketleri kayıt hatası:', e);
    }
  }
}
declare var mobilenet: any;
declare var cocoSsd: any;
declare var nsfwjs: any;